import { Loader } from 'lucide-react';

/**
 * Full-screen overlay that blocks interaction during async operations.
 *
 * @param {{ isLocked: boolean, message?: string }} props
 */
export default function LoadingOverlay({ isLocked, message = 'Please wait…' }) {
  if (!isLocked) return null;

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      zIndex: 900,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 'var(--space-md)',
      background: 'var(--overlay)',
    }}>
      <Loader size={28} style={{ animation: 'spin 0.8s linear infinite', color: 'var(--ink)' }} />
      <span style={{ fontSize: 'var(--text-sm)', color: 'var(--ink)' }}>{message}</span>
    </div>
  );
}
